// src/pages/HomePage/HomePage.jsx

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Importa nosso componente de animação e o índice das seções
import { AnimateOnScroll } from '../../components';
import {
  HomeSection,
  HotelSection,
  AccommodationsSection,
  ProgramsSection,
  SaoLourencoSection,
  ContactSection,
  LocationSection
} from '../../components/sections';

const HomePage = () => {
  const location = useLocation();

  // Efeito que observa a âncora (#) na URL e faz a rolagem
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        // Usamos um delay para garantir que as animações de entrada não atrapalhem o cálculo da posição
        setTimeout(() => {
          window.scrollTo({
            top: section.offsetTop - 70, // Offset para a altura do menu fixo
            behavior: 'smooth'
          });
        }, 300);
      }
    }
  }, [location.hash]);

  return (
    <>
      {/* A HomeSection fica de fora da animação para aparecer imediatamente ao carregar o site */}
      <HomeSection />

      {/* A partir daqui, todas as seções são envolvidas pelo AnimateOnScroll */}
      {/* O 'id' é passado para o wrapper da animação para o scroll funcionar corretamente */}
      
      <AnimateOnScroll id="o-hotel">
        <HotelSection />
      </AnimateOnScroll>

      <AnimateOnScroll id="acomodacoes">
        <AccommodationsSection />
      </AnimateOnScroll>

      <AnimateOnScroll id="programacao">
        <ProgramsSection />
      </AnimateOnScroll>

      <AnimateOnScroll id="sao-lourenco">
        <SaoLourencoSection />
      </AnimateOnScroll>

      <AnimateOnScroll id="contato">
        <ContactSection />
      </AnimateOnScroll>
      
      <AnimateOnScroll id="localizacao">
        <LocationSection />
      </AnimateOnScroll>
    </>
  );
};

export default HomePage;